import React, { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import "./TinyMCE.css";

export default function TinyMCE({
  value,
  onChange = () => {},
  height,
  toolbar,
  width,
  editor = false,
  toolbar_location,
  inline_toolbar = "",
  changeContent = () => {},
}) {
  const editorRef = useRef(null);
  return (
    <>
      <Editor
        onInit={(event, editor) => (editorRef.current = editor)}
        tinymceScriptSrc={"/tinymce/tinymce.min.js"}
        value={value}
        onEditorChange={(html, editor) => {
          const jsonContent = editor.getContent({ format: "text" });
          onChange(html);
          changeContent(jsonContent, html);
        }}
        init={{
          valid_children: "+body[style]",
          extended_valid_elements: "style[type]",
          menubar: false,
          statusbar: false,
          toolbar_mode: "wrap",
          noneditable_class: "nonedit",
          editable_class: "editable",
          ...(editor
            ? {
                placeholder: "Start writing here",
                inline: true,
                fixed_toolbar_container: ".tinymce-toolbar",
                toolbar_sticky: true,
                toolbar_sticky_offset: 108,
                height: { height },
                toolbar_mode: "floating",
                toolbar: `mergetags fontfamily fontsize  bold italic underline | ${inline_toolbar} | numlist bullist | forecolor backcolor | outdent indent | alignleft aligncenter alignright alignjustify | removeformat strikethrough link `,
              }
            : {
                placeholder: "Type something here...",
                height: height || 400,
                toolbar:
                  toolbar ||
                  " mergetags bold italic underline blockquote rewrite ",
                width: width || "100%",
                toolbar_location: toolbar_location || "auto",
              }),
          content_style: `
            body { font-family:'Inter', 'Inter Fallback', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; font-size:14px }
             table { border-collapse: collapse; width: 100%; }
             table, th, td { border: 1px solid #ccc; padding: 8px; }
          `,
          link_context_toolbar: true,
        }}
      />
    </>
  );
}
